/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function InfoCard(props) {
  let renderedTips = [];
  for (let tip of props.tips) {
    renderedTips.push(
      <div
        css={css`
          width: 100%;
        `}
      >
        <h4
          css={css`
            font-family: ${globals.menuFont};
            font-size: 16px;
            font-weight: bold;
            margin: 4px 0 0;
          `}
        >
          {tip.tip}
        </h4>
        <img
          src={tip.img}
          css={css`
            display: block;
            width: 80%;
            margin: auto;
          `}
        ></img>
      </div>
    );
  }
  return (
    <div
      css={css`
        ${globals.card}
        text-align: left;
      `}
    >
      <h4
        css={css`
          font-family: ${globals.menuFont};
          font-size: 18px;
          font-weight: bold;
          margin: 0 0 14px;
          text-transform: uppercase;
        `}
      >
        How you can keep you and your fellow Bruins healthy:
      </h4>
      {renderedTips}
    </div>
  );
}
